import React, { useState, useCallback } from 'react';
import { Tooltip, IconButton, Snackbar } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const SessionIdCopyButton = ({ sessionId, label = "Session ID" }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleCopy = useCallback(() => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(sessionId).then(() => {
        setSnackbarOpen(true);
      });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = sessionId;
      textArea.style.position = 'fixed';
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        setSnackbarOpen(true);
      } catch (err) {
        console.error('Fallback copy failed:', err);
      }
      document.body.removeChild(textArea);
    }
  }, [sessionId]);

  const handleSnackbarClose = useCallback(() => {
    setSnackbarOpen(false);
  }, []);

  if (!sessionId) {
    return null;
  }

  return (
    <>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
        <span style={{ fontSize: '12px', color: '#6b7280' }}>{label}</span>
        <Tooltip title={sessionId}>
          <IconButton
            size="small"
            onClick={handleCopy}
            style={{ padding: '2px' }}
          >
            <ContentCopyIcon style={{ fontSize: '14px' }} />
          </IconButton>
        </Tooltip>
      </span>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
        message="Copied!"
      />
    </>
  );
};

export default SessionIdCopyButton;
